import type {
    BreadcrumbProps as _BreadcrumbProps,
    BreadcrumbItemProps as _BreadcrumbItemProps,
    BreadcrumbLinkProps as _BreadcrumbLinkProps,
    BreadcrumbSeparatorProps as _BreadcrumbSeparatorProps,
} from "@chakra-ui/react";
import {
    forwardRef,
    Breadcrumb as _Breadcrumb,
    BreadcrumbItem as _BreadcrumbItem,
    BreadcrumbLink as _BreadcrumbLink,
    BreadcrumbSeparator as _BreadcrumbSeparator,
} from "@chakra-ui/react";

import { LinkWrapper } from "../link/LinkWrapper";
import { Icon } from "../../media-and-icons/icon/Icon";
import { productNameTransform } from "../../../utils/productNameTransform";

export interface BreadcrumbProps extends _BreadcrumbProps {}

export interface BreadcrumbItemProps extends _BreadcrumbItemProps {}

export interface BreadcrumbLinkProps extends _BreadcrumbLinkProps {}

export interface BreadcrumbSeparatorProps extends _BreadcrumbSeparatorProps {}

const BreadcrumbIcon = () => (
    <Icon viewBox="0 0 24 24" transform="rotate(180deg)">
        <path fill="currentColor" d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
    </Icon>
);

export const Breadcrumb = forwardRef<BreadcrumbProps, "div">(
    ({ separator = <BreadcrumbIcon />, ...props }, ref) => (
        <_Breadcrumb ref={ref} {...props} separator={separator} />
    )
);

export const BreadcrumbItem = forwardRef<BreadcrumbItemProps, "div">(({ ...props }, ref) => (
    <_BreadcrumbItem ref={ref} {...props} />
));

export const BreadcrumbLink = forwardRef<_BreadcrumbLinkProps, "a">(
    ({ as = LinkWrapper, children, ...props }, ref) => (
        <_BreadcrumbLink as={as} ref={ref} {...props}>
            {typeof children === "string" ? productNameTransform(children) : children}
        </_BreadcrumbLink>
    )
);

export const BreadcrumbSeparator = forwardRef<_BreadcrumbSeparatorProps, "span">(
    ({ ...props }, ref) => <_BreadcrumbSeparator ref={ref} {...props} />
);
